import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PrivacyNotice = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const privacySections = [
    {
      id: 1,
      title: "Data Collection & Usage",
      icon: "Database",
      content: "We collect only essential information needed to match you with appropriate helpers and facilitate secure sessions. This includes your profile preferences, session history, and feedback. Your data is never sold to third parties and is used solely to improve your support experience."
    },
    {
      id: 2,
      title: "Confidentiality Standards",
      icon: "Lock",
      content: "All sessions are confidential and protected by HIPAA regulations. Helpers are bound by professional ethics codes and organizational policies. Session content is not shared with your employer unless you provide explicit consent or there\'s a duty of care concern."
    },
    {
      id: 3,
      title: "Data Retention & Portability",
      icon: "HardDrive",
      content: "You own your data and can export or delete it at any time. Session notes and personal vault content are retained for 7 years per regulatory requirements. Inactive accounts are automatically archived after 2 years with 90-day notice."
    },
    {
      id: 4,
      title: "Security Measures",
      icon: "ShieldCheck",
      content: "End-to-end encryption for all communications, multi-factor authentication, regular security audits, and SOC 2 Type II compliance. Data is stored in geographically distributed data centers with automatic failover and backup systems."
    }
  ];

  const toggleSection = (id) => {
    setExpandedSection(expandedSection === id ? null : id);
  };

  return (
    <section className="bg-muted/20 py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4">
            <Icon name="ShieldCheck" size={28} className="text-primary" />
          </div>
          <h2 className="text-3xl font-bold text-foreground mb-3">
            Your Privacy is Protected
          </h2>
          <p className="text-lg text-muted-foreground">
            Transparent data practices and industry-leading security standards
          </p>
        </div>

        <div className="space-y-4 mb-8">
          {privacySections?.map((section) => (
            <div
              key={section?.id}
              className="bg-card rounded-lg border border-border overflow-hidden"
            >
              <button
                onClick={() => toggleSection(section?.id)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-muted/50 transition-colors duration-200"
              >
                <div className="flex items-center gap-4">
                  <div className="bg-primary/10 rounded-lg p-2 flex-shrink-0">
                    <Icon name={section?.icon} size={20} className="text-primary" />
                  </div>
                  <span className="font-semibold text-foreground">
                    {section?.title}
                  </span>
                </div>
                <Icon
                  name={expandedSection === section?.id ? "ChevronUp" : "ChevronDown"}
                  size={20}
                  className="text-muted-foreground flex-shrink-0"
                />
              </button>

              {expandedSection === section?.id && (
                <div className="px-5 pb-5 pt-2">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {section?.content}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-card rounded-lg border border-border p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-2">
                Questions About Privacy?
              </h3>
              <p className="text-sm text-muted-foreground">
                Review our complete privacy policy or contact our data protection officer
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <Button
                variant="outline"
                size="sm"
                iconName="FileText"
                iconPosition="left"
                onClick={() => window.location.href = '#privacy'}
              >
                Privacy Policy
              </Button>
              <Button
                variant="outline"
                size="sm"
                iconName="Mail"
                iconPosition="left"
                onClick={() => window.location.href = 'mailto:privacy@mindconnect.com'}
              >
                Contact DPO
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-muted-foreground">
            Last updated: December 4, 2025 • Compliant with GDPR, HIPAA, and CCPA regulations
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyNotice;